import ScrollReactTable from 'components/shared/ScrollReactTable/ScrollReactTable';
import React from 'react';
import { useSelector } from 'react-redux';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import DropModal from 'components/shared/DropModal/DropModal';
import './RoleConfigTable.css';

export const RoleConfigTable = (props) => {
  let userPermissions = useSelector((store) => store.data.rolePermissions.permissions);

  let ellipsisButton = (
    <div className={'editEllipsis'}>
      <SvgAF img={IconLoader.icon_threeV} hover={IconLoader.icon_threeV_hover} />
    </div>
  );

  const columns = (parent) => [
    {
      Header: (col) => {
        return (
          <div className="RoleConfigPage_Header_OuterDiv">
            {/* <IconAndText
                            img={IconLoader.icon_table_sort}
                            hoverImg={IconLoader.icon_table_sort_hover}
                            text={"Names"}
                            reverse
                            onClick={async () => {
                                reactTableSortOnClick(this, "role_name");
                            }}
                        /> */}
            Name
          </div>
        );
      },
      id: 'role_name',
      width: 400,
      accessor: (data) => {
        return data;
      },
      Cell: (row) => {
        return (
          <div className="RoleConfigPage_Cell_OuterDiv NameColumn" data-tip={row.value}>
            <div
              className="RoleConfigPage_NameCell"
              onClick={() => {
                props.sendTargetRoleData(row.value._id, 'READONLY');
              }}
            >
              {row.value.role}
            </div>
          </div>
        );
      }
      // sortMethod: (a,b) => {
      //     return a > b ? 1 : -1;
      // }
    },
    {
      Header: (col) => {
        return (
          <div className="RoleConfigPage_Header_OuterDiv DescriptionColumn">
            {/* <IconAndText
                            img={IconLoader.icon_table_sort}
                            hoverImg={IconLoader.icon_table_sort_hover}
                            text={"Description"}
                            reverse
                            onClick={async () => {
                                reactTableSortOnClick(this, "role_description");
                            }}
                        /> */}
            Description
          </div>
        );
      },
      id: 'role_description',
      accessor: (data) => {
        return data.description;
      },
      Cell: (row) => {
        return (
          <div className="RoleConfigPage_Cell_OuterDiv" data-tip={row.value}>
            {row.value}
          </div>
        );
      }
      // sortMethod: (a,b) => {
      //     return a > b ? 1 : -1;
      // }
    },
    {
      Header: (col) => {
        return <div className="RoleConfigPage_Header_OuterDiv EllipsisColumn"></div>;
      },
      id: 'role_editButton',
      maxWidth: 30,
      accessor: (data) => {
        return data;
      },
      Cell: (row) => {
        return (
          <div className="RoleConfigPage_Cell_OuterDiv">
            <DropModal title={ellipsisButton} name={'role_editButton' + row.value._id}>
              {userPermissions.includes('role_update') && (
                <button onClick={() => props.sendTargetRoleData(row.value._id, 'UPDATE')}>Edit</button>
              )}
              {userPermissions.includes('role_delete') && (
                <button
                  onClick={() => {
                    props.sendRoleDeleteInfo(row.value._id, row.value.role);
                  }}
                >
                  Delete
                </button>
              )}
            </DropModal>
          </div>
        );
      }
    }
  ];

  return (
    <div className="RoleConfigPage_ContentTable">
      <ScrollReactTable
        showPagination={false}
        noDataText={''}
        className={'-highlight Global_Table'}
        resizable={false}
        sortable={false}
        pageSize={props.data.length}
        minRows={18}
        data={props.data}
        overlay={null}
        fetching={false}
        columns={columns(this)}
        // sorted={sorted}
      />
    </div>
  );
};
